import { cdnBaseUrl } from '../constants';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(isSameOrBefore);

const partnerMixin = {
	props: {
		partner: {
			type: Object,
		},
	},
	data() {
		return {
			matchingOption: true,
			sendMatchingOption: false,
		};
	},
	computed: {
		isPartner() {
			return this.partner.url !== 'comento';
		},
		isRootImpact() {
			return this.partner.url === 'impactcampus';
		},
		isGreenNewDeal() {
			return this.partner.url === 'green';
		},
		isNids() {
			return this.partner.url === 'nids';
		},
		isDongjak() {
			return this.partner.url === 'dongjak';
		},
		isNyj() {
			return this.partner.url === 'nyj';
		},
		isKB() {
			return this.partner.url === 'kbstar';
		},
		isSba() {
			return this.partner.url === 'sba';
		},
		isHanyang() {
			return this.partner.url === 'hanyang';
		},
		isSmartUsg() {
			return this.partner.url === 'smart-usg';
		},
		isKvic() {
			return this.partner.url === 'kvic';
		},
		isJumpUp() {
			return this.partner.camp_type === 'jump-up';
		},
	},
	methods: {
		$_isOverEduCoupon(coupon, camp) {
			//캠프 종료일과 쿠폰희망 종료일을 비교하여, 희망종료일 안에 사용할 수 있도록 노출
			if (!coupon.camp_end_at) return false;
			if (camp.end_date.includes('9999')) return false;
			const couponDeadline = dayjs(coupon.camp_end_at).startOf('date');
			const campEndAt = dayjs(camp.end_date).startOf('date');
			return couponDeadline.isSameOrBefore(campEndAt);
		},
		async $_getMatchInfo() {
			try {
				const { data } = await this.$_fetchRequest({
					method: 'get',
					url: `/api/edu/match/current`,
					isLoading: true,
				});
				this.matchingOption = true;
				this.sendMatchingOption = Boolean(data.is_agree);
			} catch (error) {
				this.matchingOption = true;
				console.log(error);
			}
		},
		$_postMatchInfo(applicantNo, where) {
			try {
				const { data } = this.$_fetchRequest({
					method: 'post',
					url: `/api/edu/match/current`,
					isLoading: true,
					data: {
						agree: this.matchingOption,
						agreedFrom: where,
						applicantNo: applicantNo,
					},
				});
				return data;
			} catch (error) {
				console.log(error);
			}
		},
	},
	filters: {
		getImageUrl(filename) {
			return `${cdnBaseUrl}/edu/univ/${filename}`;
		},
	},
};
export default partnerMixin;
